import RedirectWidget from "../widgets/RedirectWidget";

export function InteractiveEmbeddingSettings() {
  return (
    <RedirectWidget to="/admin/settings/embedding-in-other-applications" />
  );
}
